module.exports = __webpack_public_path__ + "static/media/27.6d7a5f33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/27.jpg
// module id = 486
// module chunks = 0